import { create } from 'zustand'

/**
 * 코치마크 튜토리얼 전역 상태.
 * 튜토리얼이 홈 → 마이 탭처럼 여러 페이지에 걸쳐 이어지므로,
 * CoachMark는 라우트 트리 밖(AppRoutes)에서 전역으로 렌더하고 이 store로 on/off 한다.
 * (페이지가 바뀌어도 CoachMark 인스턴스가 유지돼 진행 상태가 보존됨)
 */
interface TutorialStore {
  active: boolean
  open: () => void
  close: () => void
}

export const useTutorialStore = create<TutorialStore>((set) => ({
  active: false,
  open: () => set({ active: true }),
  close: () => set({ active: false }),
}))
